import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { RefundInfo } from '@models/index';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class InfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    refund(): Observable<RefundInfo> {
        return this.get('member/refund', this.defaultEndpointParams);
    }
}
